import styled from '@emotion/styled';
import { useResource } from '@landsbankinn/l16n';
import { device } from '@landsbankinn/ui';
import type { ReactNode } from 'react';
import React from 'react';

import { Arrow } from '../icons/arrow';
import res from './Card.res';
import { CardItem } from './CardItem';

interface IProps {
  children: ReactNode;
  onClick?: () => void;
  className?: string;
}

const Host = styled.div<{ isClickable: boolean }>`
  width: 100%;
  background-color: white;
  position: relative;
  padding-top: 44px;
  padding-left: 34px;
  padding-right: 34px;

  cursor: ${(props) => (props.isClickable ? 'pointer' : 'initial')};
  ${(props) =>
    props.isClickable
      ? ':hover { box-shadow: 1px 12px 22px 1px rgba(0, 0, 0, 0.15); transition: all 0.5s ease-in-out; }'
      : ''}

  box-shadow: 0;
  transition: box-shadow 0.5s;
`;

const MapLinkContiner = styled.div`
  @media ${device.tablet} {
    position: absolute;
    bottom: 24px;
    cursor: pointer;
  }
`;

export function Card({ children, onClick, className }: IProps) {
  const { r } = useResource();
  return (
    <Host
      tabIndex={0}
      onClick={onClick}
      isClickable={onClick !== undefined}
      className={className}
    >
      <>
        {children}
        {onClick !== undefined && (
          <MapLinkContiner aria-hidden="true">
            <CardItem svg={<Arrow />} text={r(res.viewServices)} bold />
          </MapLinkContiner>
        )}
      </>
    </Host>
  );
}
